function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React, { useContext } from "react";
import { ImageContext } from "../../../context";
import { twMerge } from "../../../utils";
import { Body, CallToAction, Heading, HeadingBorder } from "../../atoms";
import { ArrowRight } from "../../icons";
export var IconDetailsGridCard = function(param) {
    var icon = param.icon, title = param.title, description = param.description, callToAction = param.callToAction, noTitleBorder = param.noTitleBorder, className = param.className;
    var ImageComponent = useContext(ImageContext).ImageComponent;
    return /*#__PURE__*/ React.createElement("article", {
        className: twMerge("grid grid-cols-1 grid-rows-[auto_1fr] auto-rows-max gap-5 h-full", className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-center sm:justify-start"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col items-center"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _extends({}, icon, {
        className: "block h-[3rem] w-auto"
    })), /*#__PURE__*/ React.createElement("div", {
        role: "presentation",
        className: "mt-4 w-8 h-2 bg-gray-medium rounded-[100%] blur-sm"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: twMerge("grid gap-5 grid-cols-1 grid-flow-row auto-rows-max text-center sm:text-left", !description && callToAction && "grid-rows-[1fr_auto]", description && callToAction && "grid-rows-[auto_1fr_auto]")
    }, noTitleBorder ? /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3"
    }, title.split("<br/>").join("\n")) : /*#__PURE__*/ React.createElement(HeadingBorder, null, /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3"
    }, title.split("<br/>").join("\n"))), !!description && /*#__PURE__*/ React.createElement(Body, {
        className: "opacity-60"
    }, description), !!callToAction && /*#__PURE__*/ React.createElement("div", {
        className: "mt-auto flex justify-center sm:justify-start"
    }, /*#__PURE__*/ React.createElement(CallToAction, _extends({
        style: "link",
        linkVariant: "default",
        icon: /*#__PURE__*/ React.createElement(ArrowRight, null)
    }, callToAction), callToAction.label))));
};

//# sourceMappingURL=IconDetailsGridCard.js.map